import "./TeamMember.css";

export default function TeamMember(props) {
    return (
        <div className="teamMember">
            <img className="teamMemberImg" src={props.img} />

            <p className="teamMemberName">{props.name}</p>
        </div>
    );
}